export interface IPaystub {
    id: number;
    requestId: number;
    grossAmount: number;
    startDate: string;
    endDate: string;
    createdDate: string;
    updatedById?: number;
    lastUpdatedDate?: string;
    paystubFile?: string;
    paystubFileUploadedDateTime?: string;
    paystubFileId?: number;
    paystubSequence?: number;
    paystubFileName?: string;
    reviewRequired?: boolean;
}

